import ModalContainer from "./ModalContainer";
import "./ConfirmPopup.scss";
import { cn } from "../../lib/utils";

function renderAlertMessage(message) {
	const [prefix, emphasis, suffix] = message.split(/<\/?b>/);

	if (emphasis === undefined) return message;

	return (
		<>
			{prefix}
			<strong>{emphasis}</strong>
			{suffix}
		</>
	);
}

export default function ConfirmModal({
	open,
	setOpen,
	title,
	subtitle,
	icon,
	description,
	counterGoals,
	counterCaphters,
	counterActions,
	counterContents,
	alertMessage,
	ctaLabel,
	onConfirm = () => {},
	onCancel,
	isSuccess,
	isLoading,
}) {
	return (
		<ModalContainer isOpen={open} setIsOpen={setOpen}>
			<div className={"main_modal_content confirm_popup"}>
				<button
					className="main_close"
					onClick={() => setOpen(false)}
					type="button"
					aria-label="Chiudi"
				>
					<span className="icon_10 default close icon_mask !bg-white"></span>
				</button>

				<div className="main_header_modal left_text">
					<span className="title">{title}</span>
				</div>

				{/* Modal Content */}
				<div className={"main_body_modal"}>
					{/* Subtitle */}
					{subtitle && (
						<div className="main_subtitle">
							{icon && (
								<div className="main_icon">
									<span className={icon}></span>
								</div>
							)}
							<span className="subtitle">{subtitle}</span>
						</div>
					)}

					{/* Description */}
					{description && <div className="main_description">{description}</div>}

					{/* Counters */}
					{(counterCaphters != null ||
						counterContents != null ||
						counterGoals != null ||
						counterActions != null) && (
						<div className="main_counter_container">
							{/* Counter chapter */}
							{counterCaphters != null && (
								<div className="main_counter">
									<div className="main_icon">
										<span className="icon_16 folder default"></span>
									</div>
									{counterCaphters}
								</div>
							)}

							{/* counter contents */}
							{counterContents != null && (
								<div className="main_counter">
									<div className="main_icon">
										<span className="icon_16 default text_box"></span>
									</div>
									{counterContents}
								</div>
							)}

							{/* counter goals */}
							{counterGoals != null && (
								<div className="main_counter">
									<div className="main_icon">
										<span className="icon_16 layers default"></span>
									</div>
									{counterGoals}
								</div>
							)}

							{/* counter actions */}
							{counterActions != null && (
								<div className="main_counter">
									<div className="main_icon">
										<span className="icon_16 layer default"></span>
									</div>
									{counterActions}
								</div>
							)}
						</div>
					)}

					{alertMessage && (
						<div className="main_alert_message">
							<div className="main_icon">
								<span className="icon_16 default danger"></span>
							</div>
							<div className="message">{renderAlertMessage(alertMessage)}</div>
						</div>
					)}
				</div>

				<div className="main_footer_modal">
					<button
						type="button"
						onClick={() => (onCancel ? onCancel() : setOpen(false))}
						className="button line"
					>
						Annulla
					</button>

					<button
						type="button"
						onClick={onConfirm}
						className={cn("button fill", isSuccess ? "success" : "error", isLoading && "loading")}
					>
						<div className="load_content">{ctaLabel}</div>
						<div className="main_loader_icon fade_in"></div>
					</button>
				</div>
			</div>
		</ModalContainer>
	);
}
